module.exports = __webpack_public_path__ + "static/media/YM70_1.4dd30476.jpg";